<template>
	<section class="view-example" v-bind:class="[...className]">
		<p>Example view</p>
	</section>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';
	import { mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View
	 * @project ChalkySticks
	 */
	@Component
	export default class ViewExample extends ViewBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.view-example {
		// Not implemented
	}
</style>
